export const CRYSTAL_COLORS = {
    // Available pattern options:
    // pattern: 'solid'     - No pattern, just solid color
    // pattern: 'stripes'   - Diagonal stripes
    // pattern: 'dots'      - Small circular dots
    // pattern: 'grid'      - Square grid pattern
    // pattern: 'diagonalCheckers -- I don't like this one
    // pattern: 'waves'     - circular wavey pattern
    // pattern: 'trianges'  - Triangle pattern overlay
    
    light: {
        0: { color: 'rgb(255, 80, 80)', pattern: 'solid' },    // Bright Red
        1: { color: 'rgb(80, 255, 120)', pattern: 'solid' },   // Bright Green
        2: { color: 'rgb(80, 120, 255)', pattern: 'solid' },   // Bright Blue
        3: { color: 'rgb(255, 255, 80)', pattern: 'solid' },   // Lemon Yellow
        4: { color: 'rgb(240, 80, 240)', pattern: 'solid' },   // Bright Magenta
        5: { color: 'rgb(80, 240, 240)', pattern: 'solid' },   // Bright Cyan
        6: { color: 'rgb(255, 160, 60)', pattern: 'solid' },   // Bright Orange
        7: { color: 'rgb(160, 60, 240)', pattern: 'stripes' },    // Vivid Purple (similar to Bright Magenta)
        8: { color: 'rgb(60, 160, 60)', pattern: 'stripes' },    // Deep Forest Green
        9: { color: 'rgb(255, 140, 170)', pattern: 'stripes' },  // Warm Pink
        10: { color: 'rgb(120, 120, 255)', pattern: 'stripes' }, // Cool Light Blue
        11: { color: 'rgb(120, 255, 120)', pattern: 'stripes' }, // Soft Light Green
        12: { color: 'rgb(200, 120, 60)', pattern: 'stripes' },  // Rich Brown
        13: { color: 'rgb(60, 160, 220)', pattern: 'stripes' }, // Clear Sky Blue (similar to Cool Light Blue)
        14: { color: 'rgb(240, 200, 60)', pattern: 'stripes' },  // Bright Gold
        15: { color: 'rgb(160, 60, 100)', pattern: 'stripes' },  // Rich Burgundy
        16: { color: 'rgb(60, 100, 160)', pattern: 'stripes' },   // Clear Steel Blue (similar to Sky Blue)
        17: { color: 'rgb(220, 220, 100)', pattern: 'stripes' }, // Bright Khaki
        18: { color: 'rgb(120, 160, 120)', pattern: 'dots' }, // Soft Sage (similar to Soft Light Green)
        19: { color: 'rgb(160, 120, 220)', pattern: 'dots' }, // Bright Lavender
        20: { color: 'rgb(220, 60, 100)', pattern: 'dots' },  // Bold Crimson
        21: { color: 'rgb(60, 220, 180)', pattern: 'dots' },  // Clear Turquoise
        22: { color: 'rgb(160, 220, 60)', pattern: 'grid' },  // Vibrant Lime
        23: { color: 'rgb(220, 120, 160)', pattern: 'grid' },  // Soft Rose (similar to Warm Pink)
        24: { color: 'rgb(120, 160, 220)', pattern: 'grid' },   // Soft Periwinkle
        // 🌀 Waves Pattern (25–38)
        25: { color: 'rgb(255, 100, 100)', pattern: 'waves' }, // Bright Red Waves
        26: { color: 'rgb(100, 255, 100)', pattern: 'waves' }, // Bright Green Waves
        27: { color: 'rgb(100, 100, 255)', pattern: 'waves' }, // Bright Blue Waves
        28: { color: 'rgb(255, 255, 100)', pattern: 'waves' }, // Bright Yellow Waves
        29: { color: 'rgb(255, 150, 200)', pattern: 'waves' }, // Warm Pink Waves
        30: { color: 'rgb(150, 100, 200)', pattern: 'waves' }, // Soft Purple Waves
        31: { color: 'rgb(100, 200, 255)', pattern: 'waves' }, // Sky Blue Waves
        32: { color: 'rgb(200, 255, 100)', pattern: 'waves' }, // Lime Green Waves
        33: { color: 'rgb(255, 180, 80)', pattern: 'waves' },  // Warm Orange Waves
        34: { color: 'rgb(80, 180, 255)', pattern: 'waves' },  // Clear Blue Waves
        35: { color: 'rgb(180, 100, 255)', pattern: 'waves' }, // Vivid Purple Waves
        36: { color: 'rgb(100, 255, 200)', pattern: 'waves' }, // Aqua Waves
        37: { color: 'rgb(255, 200, 150)', pattern: 'waves' }, // Peach Waves
        38: { color: 'rgb(150, 255, 150)', pattern: 'waves' }, // Pastel Green Waves

        // 🔺 Triangles Pattern (39–50)
        39: { color: 'rgb(255, 100, 100)', pattern: 'triangles' }, // Bright Red Triangles
        40: { color: 'rgb(100, 255, 100)', pattern: 'triangles' }, // Bright Green Triangles
        41: { color: 'rgb(100, 100, 255)', pattern: 'triangles' }, // Bright Blue Triangles
        42: { color: 'rgb(255, 255, 100)', pattern: 'triangles' }, // Bright Yellow Triangles
        43: { color: 'rgb(255, 150, 200)', pattern: 'triangles' }, // Warm Pink Triangles
        44: { color: 'rgb(150, 100, 200)', pattern: 'triangles' }, // Soft Purple Triangles
        45: { color: 'rgb(100, 200, 255)', pattern: 'triangles' }, // Sky Blue Triangles
        46: { color: 'rgb(200, 255, 100)', pattern: 'triangles' }, // Lime Green Triangles
        47: { color: 'rgb(255, 180, 80)', pattern: 'triangles' },  // Warm Orange Triangles
        48: { color: 'rgb(80, 180, 255)', pattern: 'triangles' },  // Clear Blue Triangles
        49: { color: 'rgb(180, 100, 255)', pattern: 'triangles' }, // Vivid Purple Triangles
        50: { color: 'rgb(100, 255, 200)', pattern: 'triangles' }  // Aqua Triangles
    },
    dark: {
        0: { color: 'rgb(200, 50, 50)', pattern: 'solid' },    // Dark Red
        1: { color: 'rgb(50, 200, 90)', pattern: 'solid' },    // Dark Green
        2: { color: 'rgb(50, 90, 200)', pattern: 'solid' },    // Dark Blue
        3: { color: 'rgb(200, 200, 50)', pattern: 'solid' },   // Golden Yellow
        4: { color: 'rgb(180, 50, 180)', pattern: 'solid' },   // Dark Magenta
        5: { color: 'rgb(50, 180, 180)', pattern: 'solid' },   // Deep Cyan
        6: { color: 'rgb(200, 120, 40)', pattern: 'solid' },   // Deep Orange
        7: { color: 'rgb(120, 40, 200)', pattern: 'stripes' },    // Dark Purple (similar to Dark Magenta)
        8: { color: 'rgb(40, 120, 40)', pattern: 'stripes' },    // Dark Forest Green
        9: { color: 'rgb(200, 100, 130)', pattern: 'stripes' },  // Deep Pink
        10: { color: 'rgb(100, 100, 200)', pattern: 'stripes' }, // Dark Light Blue
        11: { color: 'rgb(100, 200, 100)', pattern: 'stripes' }, // Dark Light Green
        12: { color: 'rgb(140, 80, 40)', pattern: 'stripes' },   // Dark Brown
        13: { color: 'rgb(40, 120, 160)', pattern: 'stripes' }, // Deep Sky Blue (similar to Dark Light Blue)
        14: { color: 'rgb(160, 120, 40)', pattern: 'stripes' },  // Dark Gold
        15: { color: 'rgb(120, 40, 80)', pattern: 'stripes' },   // Deep Burgundy
        16: { color: 'rgb(40, 80, 120)', pattern: 'stripes' },    // Dark Steel Blue (similar to Deep Sky Blue)
        17: { color: 'rgb(160, 160, 80)', pattern: 'dots' },  // Muted Khaki
        18: { color: 'rgb(80, 120, 80)', pattern: 'dots' }, // Muted Sage (similar to Dark Light Green)
        19: { color: 'rgb(120, 80, 160)', pattern: 'dots' }, // Deep Lavender
        20: { color: 'rgb(160, 40, 80)', pattern: 'dots' },   // Dark Crimson
        21: { color: 'rgb(40, 160, 120)', pattern: 'dots' },  // Deep Turquoise
        22: { color: 'rgb(120, 160, 40)', pattern: 'grid' },  // Dark Lime
        23: { color: 'rgb(160, 80, 120)', pattern: 'grid' },   // Deep Rose (similar to Deep Pink)
        24: { color: 'rgb(80, 120, 160)', pattern: 'grid' },    // Deep Periwinkle
        // 🌀 Waves Pattern (25–38)
        25: { color: 'rgb(180, 50, 50)', pattern: 'waves' },  // Deep Crimson Waves
        26: { color: 'rgb(50, 180, 50)', pattern: 'waves' },  // Emerald Waves
        27: { color: 'rgb(50, 50, 180)', pattern: 'waves' },  // Sapphire Waves
        28: { color: 'rgb(180, 180, 50)', pattern: 'waves' }, // Golden Waves
        29: { color: 'rgb(200, 80, 120)', pattern: 'waves' }, // Dark Pink Waves
        30: { color: 'rgb(120, 80, 200)', pattern: 'waves' }, // Royal Purple Waves
        31: { color: 'rgb(80, 200, 200)', pattern: 'waves' }, // Deep Aqua Waves
        32: { color: 'rgb(200, 150, 80)', pattern: 'waves' }, // Burnt Orange Waves
        33: { color: 'rgb(90, 130, 200)', pattern: 'waves' }, // Steel Blue Waves
        34: { color: 'rgb(200, 90, 60)', pattern: 'waves' },  // Brick Red Waves
        35: { color: 'rgb(100, 200, 160)', pattern: 'waves' }, // Teal Waves
        36: { color: 'rgb(160, 100, 200)', pattern: 'waves' }, // Plum Waves
        37: { color: 'rgb(200, 160, 100)', pattern: 'waves' }, // Amber Waves
        38: { color: 'rgb(100, 160, 200)', pattern: 'waves' }, // Frost Blue Waves

        // 🔺 Triangles Pattern (39–50)
        39: { color: 'rgb(180, 50, 50)', pattern: 'triangles' }, // Deep Crimson Triangles
        40: { color: 'rgb(50, 180, 50)', pattern: 'triangles' }, // Emerald Triangles
        41: { color: 'rgb(50, 50, 180)', pattern: 'triangles' }, // Sapphire Triangles
        42: { color: 'rgb(180, 180, 50)', pattern: 'triangles' }, // Golden Triangles
        43: { color: 'rgb(200, 80, 120)', pattern: 'triangles' }, // Dark Pink Triangles
        44: { color: 'rgb(120, 80, 200)', pattern: 'triangles' }, // Royal Purple Triangles
        45: { color: 'rgb(80, 200, 200)', pattern: 'triangles' }, // Deep Aqua Triangles
        46: { color: 'rgb(200, 150, 80)', pattern: 'triangles' }, // Burnt Orange Triangles
        47: { color: 'rgb(90, 130, 200)', pattern: 'triangles' }, // Steel Blue Triangles
        48: { color: 'rgb(200, 90, 60)', pattern: 'triangles' },  // Brick Red Triangles
        49: { color: 'rgb(100, 200, 160)', pattern: 'triangles' }, // Teal Triangles
        50: { color: 'rgb(160, 100, 200)', pattern: 'triangles' } // Plum Triangles
    }
};

export const THEME_COLORS = {
    light: {
        background: 'bg-gradient-to-b from-blue-50 to-purple-200',
        header: 'bg-gray-50',
        container: 'bg-gray-100',
        containerHover: 'hover:bg-gray-200',
        containerBg: 'bg-gray-50',
        text: 'text-gray-900',
        subtext: 'text-gray-700',
        border: 'border-gray-300',
        button: 'bg-gray-200 hover:bg-gray-300',
        selectedBorder: 'border-yellow-500',
        validTargetBorder: 'border-green-500',
        hintFromBorder: 'border-cyan-400',
        hintToBorder: 'border-emerald-400',
        input: 'bg-white border-gray-300'
    },
    dark: {
        background: 'bg-gradient-to-b from-gray-800 to-purple-900',
        header: 'bg-gray-700',
        container: 'bg-gray-700',
        containerHover: 'hover:bg-gray-600',
        containerBg: 'bg-gray-700',
        text: 'text-gray-200',
        subtext: 'text-gray-400',
        border: 'border-gray-600',
        button: 'bg-gray-600 hover:bg-gray-500',
        selectedBorder: 'border-yellow-600',
        validTargetBorder: 'border-green-600',
        hintFromBorder: 'border-cyan-400',
        hintToBorder: 'border-emerald-400',
        input: 'bg-gray-600 border-gray-500'
    }
};

export const getThemeColors = (isDarkMode) => {
    return THEME_COLORS[isDarkMode ? 'dark' : 'light'];
};

export const getCrystalColors = (isDarkMode) => {
    return CRYSTAL_COLORS[isDarkMode ? 'dark' : 'light'];
};